import { OfferReturnStrategy, RollbackStackingConfig } from './types';

export const fallbackRollbackStackingConfig: RollbackStackingConfig = 'OFF';
export const fallbackOfferReturnStrategy: OfferReturnStrategy = 'OFF';
